import { Icon } from '@design/components/icon/Icon';
import clsx from 'clsx';
import { Property } from 'csstype';
import React from 'react';

import styles from './TableHeaderIcons.module.scss';

export interface TableHeaderIconsProps {
  alignment?: Property.TextAlign;
  sortDirection?: 'asc' | 'desc' | false;
  isPinned?: boolean;
  isFiltered?: boolean;
  children: React.ReactNode;
}

export const TableHeaderIcons = ({
  alignment = 'end',
  sortDirection = false,
  isPinned = false,
  isFiltered = false,
  children,
}: TableHeaderIconsProps) => {
  const reversedAlignments = ['end', 'right'];
  const isReversed = reversedAlignments.includes(alignment);

  return (
    <span className={clsx(styles.root, isReversed && styles.isReversed)}>
      {children}
      {!!sortDirection && (
        <Icon
          className={styles.sortIcon}
          data-element="sort-icon"
          iconName={sortDirection === 'asc' ? 'SortAscLeft' : 'SortDescLeft'}
          size={12}
        />
      )}
      {isPinned && (
        <Icon className={styles.pinIcon} iconName="PinSolid" size={10} />
      )}
      {isFiltered && (
        <Icon className={styles.filterIcon} iconName="Filter" size={10} />
      )}
    </span>
  );
};
